import Vue from 'vue/dist/vue.esm.js'
Vue.component 'user-report-rows-agreement-row',
  template: JST['user_report_rows/agreement_row']()
  props: ['initialRow']

  created: ->
    @updateRow = _.debounce(@updateRow, ReportRowConfig.wait)

  data: ->
    row: @initialRow
    errors: {}

  computed:
    rowId: ->
      "row-#{@row.id}"

  watch:
    row:
      handler: -> @updateRow()
      deep: true

  methods:
    updateRow: ->
      $.ajax
        dataType: 'JSON',
        url: "/project_partners/#{@row.project_partner_id}/report_agreement_rows/#{@row.id}"
        method: 'PUT'
        data: _.pick(@row, ['client_notes'])
        success: =>
          Helper.flashRow($(@$el), '#bfdf9f')
      @.$emit('update-row', @row)
